import { MULTI_BRANCH } from '../../config/branches';

/**
 * Marca la version de prueba (VITE_MULTI_BRANCH=true) para que nadie la
 * confunda con la web publica, y le pone noindex por si el servidor no lo
 * hiciera (el workflow de pruebas tambien manda X-Robots-Tag y robots.txt).
 * En la web publica no pinta nada.
 */
export default function StagingBadge() {
  if (!MULTI_BRANCH) return null;
  return (
    <>
      <meta name="robots" content="noindex, nofollow" />
      <div
        role="status"
        className="fixed bottom-3 left-1/2 -translate-x-1/2 z-[300] pointer-events-none rounded-full bg-[#1f1f1f] px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-widest text-[#ffffff] shadow-lg"
      >
        Versión de prueba · Sucursales
      </div>
    </>
  );
}
